import React, { useState, useCallback, useEffect } from 'react';
import { Popup } from 'devextreme-react/popup';
import { useApiMicrobiology } from '../../../api/api.microbiology';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { useScreenSize } from '../../../utils/media-query';
import { MicroorganismsCatalog } from './MicroorganismsCatalog';
import { AntibioticsCatalog } from './AntibioticosCatalog';
import { SysI_MicrobiologiaAntibioticosCatalogo, SysI_MicrobiologiaMicroorganismosCatalogo } from '../../../types/types.microbiology';

interface ModalMicrobiologyCatalogsProps {
  initialTab?: number; // 0 = Microorganismos, 1 = Antibióticos
}

export const ModalMicrobiologyCatalogs: React.FC<ModalMicrobiologyCatalogsProps> = ({ initialTab = 0 }) => {
  const [selectedTab, setSelectedTab] = useState(initialTab);
  const [microorganismos, setMicroorganismos] = useState<SysI_MicrobiologiaMicroorganismosCatalogo[]>([]);
  const [antibioticos, setAntibioticos] = useState<SysI_MicrobiologiaAntibioticosCatalogo[]>([]);
  const { getMicroorganismos, getAntibioticos } = useApiMicrobiology();

  useEffect(() => {
    handleUpdateData();
  }, []);

  const handleUpdateData = () => {
    getMicroorganismos().then((res) => {
      setMicroorganismos(res);
    });

    getAntibioticos().then((res) => {
      setAntibioticos(res);
    });
  };

  const handleTabChange = useCallback((e: any) => {
    setSelectedTab(e.component.option('selectedIndex'));
  }, []);

  return (
    <div>
      <div className='modal-microbiology-content'>
        <div>
          <p>Configure los catálogos maestros que se utilizarán en la captura y reporte de resultados microbiológicos.</p>
        </div>

        <TabPanel height='100%' selectedIndex={selectedTab} onSelectionChanged={handleTabChange} animationEnabled={true} swipeEnabled={false}>
          <TabItem title='Microorganismos' icon='orderedlist'>
            <MicroorganismsCatalog dataMicroorganismos={microorganismos} update={handleUpdateData} />
          </TabItem>

          <TabItem title='Antibióticos' icon='orderedlist'>
            <AntibioticsCatalog dataAntibioticos={antibioticos} update={handleUpdateData} />
          </TabItem>
        </TabPanel>
      </div>
    </div>
  );
};
